import { Cookies } from '../../../../utility/cookies';
import { LOOP54_ANONYMOUS_USER_COOKIE } from './cookieKeys';

const loop54UserSession = {
    get: () => {
        const rawCookie = Cookies.read(LOOP54_ANONYMOUS_USER_COOKIE);
        return rawCookie;
    },
    set: (anonymousId: string) => {
        Cookies.create(LOOP54_ANONYMOUS_USER_COOKIE, anonymousId, 365);
    },
};

export default loop54UserSession;
